<template lang='pug'>
  v-app
    v-app-bar(color="#005cb8" flat dense app)
      a(href="https://arlingtonva.us" aria-label="Arlington County - Home").mx-2
        v-img.my-auto(max-height="62" max-width="200" position="top, left" src="CountyLogo_Reverse_Horizontal.png")
      v-spacer
      div.d-none.d-lg-block
        v-btn(text color="white" v-for="link in links" :key="link.title" :href="link.url" :title="link.title" target="_blank") {{link.title}}
      v-menu(bottom left)
        template(v-slot:activator="{ on, attrs }")
          v-btn(icon color="white" v-bind="attrs" v-on="on" aria-label="Open navigation menu").d-lg-none
            v-icon(aria-hidden="true") mdi-menu
        v-list(role="menu")
          v-list-item(v-for="link in links" :key="link.title" role="menuitem")
            v-btn(text :href="link.url" :title="link.title" target="_blank") {{link.title}}
    v-main
      router-view
    v-footer(color="#005cb8")
      p.ma-auto.white--text.body-2 Copyright © {{new Date().getFullYear()}} Arlington County Virginia
</template>

<script>
export default {
  data: () => ({
    links: [
      { url: "https://docs.data.arlingtonva.us", title:"How-To Guide" },
      { url: "https://www.arlingtonva.us/Home/Terms-Conditions", title: "Terms of Use" },
      { url: "https://www.arlingtonva.us/Government/Topics/Policy", title: "Policy" },
      { url: "https://www.arlingtonva.us/Government/Topics/Data-Blog", title: "Data Matters Blog" },
      { url: "https://www.arlingtonva.us/Government/Topics/Open-Data-Feedback-Form", title: "Feedback" },
      { url: "https://www.arlingtonva.us/Government/Topics/Open-Arlington", title:"Other Open Resources" }
    ]
  })
}
</script>

<style lang="stylus">
  $body-font-family = 'Open Sans', Arial, sans-serif

  .v-toolbar .v-btn__content
    color: white

  $acg-blue: #005cbb
  $acg-light-blue: #005cb8
  $acg-grey: #666
  $link-hover: #7ac4fc

  // ACG head fixes
  #top-links
    display:flex
    justify-content: center
    padding-left: 16px
    padding-right: 16px
    > div
      margin: 0 auto
      width: 100%
      display:flex
      flex-wrap: wrap
      justify-content: space-between
    .logo
      position: relative
      i
        position: relative
        top: 8px
    .holder-inner
      font-size: 1rem
  @media all and (min-width:960px)
    #top-links > div
      max-width: 852px
  @media all and (min-width:1264px)
    #top-links > div
      max-width: 1137px
  @media all and (min-width:1904px)
    #top-links > div
      max-width: 1737px
  .bull
    margin: 0 5px 0 5px
    padding: 0 5px 0 5px

  // ACG body fixes
  table
    border: 0px
  th, td
    vertical-align: middle
  tr:first-child
    background-color: #fff
    color: rgba(0,0,0,0.87)
    td
      font-weight: normal
  tr:nth-child(odd)
    background-color: #fff
  .acg-big
    font-size: 1.3em !important
  .acg-small
    font-size: 13px !important
  h1.acg-heading
    color: black
  h2.acg-subheading
    color: black
    font-size: 3.2em
  div.v-calendar-weekly__day-label, div.v-calendar-weekly__day-month
    font-size: .9rem

  .card-heading
    color: #015cb9
    font-size: 18px
    margin: 0
  .card-subheading
    color: #717171
    font-size: 14px
    margin: 0
  .card-spacer
    height: 10px
  .card-text
    font-size: 13px
    margin: 0
  .btn-card:hover
    background-color: #CFD8DC
  .btn-card .title
    color: #0277BD
  .btn-card
    padding: 10px

  footer small
    font-size: 10px

  .vue-line-clamp
    word-break: normal !important

  main img
    background: rgba(255, 255, 255, 0);

  .holder-inner::-webkit-scrollbar {
    display: none;
  }
  .holder-inner {
    -ms-overflow-style: none;
  }
  a::after {
    content: none !important;
  }
  .no-decoration {
    text-decoration: none;
  }
</style>